import { useRef } from 'react';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { useQuery } from 'shared/helpers/RoutingHelpers';
import { InstantTransferDialogContent } from 'shared/modules/superpay/instant-transfer/InstantTransferDialogContent';
import { CarrierWebviewHeader } from '../CarrierWebviewHeader';

export function InstantTransferWebViewDialog() {
  const [{ load_id }] = useQuery();
  const didNotifyNative = useRef(false);

  return (
    <CarrierWebviewHeader>
      <InstantTransferDialogContent
        loadID={load_id}
        source="Instant Transfer Offer"
        onSuccess={() => {
          didNotifyNative.current = true;
          MobileAppBridge.successAndClose('Payment submitted successfully.');
        }}
        onClose={() => {
          if (!didNotifyNative.current) {
            MobileAppBridge.closeScreen();
          }
        }}
      />
    </CarrierWebviewHeader>
  );
}
